import { z } from 'zod';

const NEED_TOTAL_MIN_LENGTH = 1;
const NEED_TOTAL_MAX_LENGTH = 100;

export const GenerateQSetFormSchema = z.object({
  qConfig: z.object(
    {
      value: z.string(),
      label: z.string(),
    },
    { message: 'กรุณาเลือก QConfig' },
  ),
  duplicationRate: z.number({ message: 'กรุณากำหนดค่าความซ้ำระหว่างชุด' }),
  needTotal: z
    .number({ message: 'กรุณากำหนดจำนวนชุดข้อสอบ' })
    .min(NEED_TOTAL_MIN_LENGTH, { message: `กรุณาระบุอย่างน้อย ${NEED_TOTAL_MIN_LENGTH} ชุด` })
    .max(NEED_TOTAL_MAX_LENGTH, { message: `กรุณาระบุไม่เกิน ${NEED_TOTAL_MAX_LENGTH} ชุด` }),
});

export type GenerateQSetFormInput = z.infer<typeof GenerateQSetFormSchema>;
